/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_System_Status_LabelInputs */

const bn_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ট্যাটাস`)
};

const de_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STATUS`)
};

const el_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΚΑΤΑΣΤΑΣΗ`)
};

const en_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STATUS`)
};

const es_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ESTADO`)
};

const fr_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STATUT`)
};

const hi_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति`)
};

const hu_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ÁLLAPOT`)
};

const id_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STATUS`)
};

const it_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STATO`)
};

const ja_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状態`)
};

const ko_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상태`)
};

const nl_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STATUS`)
};

const pl_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STATUS`)
};

const pt_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STATUS`)
};

const ru_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`СТАТУС`)
};

const sv_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`STATUS`)
};

const tr_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DURUM`)
};

const uk_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`СТАТУС`)
};

const vi_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRẠNG THÁI`)
};

const zh_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地位`)
};

const zh_hant_cipher_system_status_label = /** @type {(inputs: Cipher_System_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地位`)
};

/**
* | output |
* | --- |
* | "STATUS" |
*
* @param {Cipher_System_Status_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_system_status_label = /** @type {((inputs?: Cipher_System_Status_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_System_Status_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_system_status_label(inputs)
	if (locale === "de") return de_cipher_system_status_label(inputs)
	if (locale === "el") return el_cipher_system_status_label(inputs)
	if (locale === "en") return en_cipher_system_status_label(inputs)
	if (locale === "es") return es_cipher_system_status_label(inputs)
	if (locale === "fr") return fr_cipher_system_status_label(inputs)
	if (locale === "hi") return hi_cipher_system_status_label(inputs)
	if (locale === "hu") return hu_cipher_system_status_label(inputs)
	if (locale === "id") return id_cipher_system_status_label(inputs)
	if (locale === "it") return it_cipher_system_status_label(inputs)
	if (locale === "ja") return ja_cipher_system_status_label(inputs)
	if (locale === "ko") return ko_cipher_system_status_label(inputs)
	if (locale === "nl") return nl_cipher_system_status_label(inputs)
	if (locale === "pl") return pl_cipher_system_status_label(inputs)
	if (locale === "pt") return pt_cipher_system_status_label(inputs)
	if (locale === "ru") return ru_cipher_system_status_label(inputs)
	if (locale === "sv") return sv_cipher_system_status_label(inputs)
	if (locale === "tr") return tr_cipher_system_status_label(inputs)
	if (locale === "uk") return uk_cipher_system_status_label(inputs)
	if (locale === "vi") return vi_cipher_system_status_label(inputs)
	if (locale === "zh") return zh_cipher_system_status_label(inputs)
	return zh_hant_cipher_system_status_label(inputs)
});